import { MobileModalFooter } from '../MobileComponents/Modal/MobileModalFooter'
import ADefaultModalFooter from '../DefaultModalFooter/ADefaultModalFooter'
import { Progress, Text, defaultTheme } from '@agro-club/agroclub-shared'
import { AMobileModal } from '../MobileComponents/Modal/AMobileModal'
import { ASharedModal, SharedModalTitle } from '../SharedModal'
import { useMediaQuery } from 'react-responsive'
import { CSSProperties, FC, ReactNode } from 'react'

type CommonProps = {
  size?: 'small' | 'large' | 'medium' | 'extraLarge'
  children: ReactNode
  onClose: () => void
  title: ReactNode
  id: string
  contentStyle?: CSSProperties
  headerHeight?: number
}

type DefaultBtnProps = {
  confirmButtonText?: string
  onConfirm?: () => void
  progress?: Progress
  disabled?: boolean
} & CommonProps

type CustomFooterProps = {
  customFooter?: ReactNode
} & CommonProps

const isCustomFooterProps = (props: DefaultBtnProps | CustomFooterProps): props is CustomFooterProps => {
  return 'customFooter' in props && props.customFooter !== undefined
}

export const ResponsiveModal: FC<DefaultBtnProps | CustomFooterProps> = (props) => {
  const { children, onClose, title, size, id, ...otherProps } = props

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  return (
    <>
      {isMobile ? (
        <AMobileModal
          header={<Text typography="titleH4">{title}</Text>}
          headerHeight={props.headerHeight}
          onClose={onClose}
          id={id}
        >
          {children}
          {isCustomFooterProps(props) ? (
            props.customFooter
          ) : (
            <MobileModalFooter
              progress={props.progress}
              confirmButtonText={props.confirmButtonText}
              onConfirm={props.onConfirm}
              disabled={props.disabled}
            />
          )}
        </AMobileModal>
      ) : (
        <ASharedModal id={id} onClose={onClose} size={size} {...otherProps}>
          <SharedModalTitle>{title}</SharedModalTitle>
          {children}
          {isCustomFooterProps(props) ? (
            props.customFooter
          ) : (
            <ADefaultModalFooter
              confirmButtonText={props.confirmButtonText}
              onConfirm={props.onConfirm}
              progress={props.progress}
              onClose={onClose}
              disabled={props.disabled}
            />
          )}
        </ASharedModal>
      )}
    </>
  )
}
